import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PagePending } from './-components/page-pending';

export const Route = createFileRoute('/new/contact')({
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return <PagePending title={t`Contact`} />;
}
